import React, { useMemo } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { useAppSelector } from '@store/index'
import { theme } from './theme'
import { UserRole } from '@/types'

interface DynamicThemeProviderProps {
  children: React.ReactNode
}

/**
 * Dynamic theme provider that applies role-based theming
 * Automatically switches theme colors based on the logged-in user's role
 */
export const DynamicThemeProvider: React.FC<DynamicThemeProviderProps> = ({
  children,
}) => {
  const user = useAppSelector(state => state.auth?.user)

  // Default to no role if no user is logged in
  const userRole = user?.role || null

  // Memoize theme to avoid unnecessary recreations
  const currentTheme = useMemo(() => theme(userRole), [userRole])

  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
